import "@/elements/booking-element/dialog/booking-dialog-element";
import "@/elements/booking-element/button/booking-button-element";

import { setDefaultLocale } from "@/elements/localization/localization.utilities";

void setDefaultLocale();

new MutationObserver(() => void setDefaultLocale()).observe(
  document.documentElement,
  { attributes: true, attributeFilter: ["lang"] },
);
